// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3BJuZ2DV6k8INqt2udNCg"};